import { AbstractControl, ValidationErrors } from "@angular/forms";

export function validateLogin(control: AbstractControl): ValidationErrors | null {

    const { username, password } = control.value;

    if (!username || !password)
        return { loginInvalid: true };

    return null;
}